export async function fetchData(apiUrl, options = {}) {
    if (!apiUrl) throw new Error('No apiUrl provided to fetchData');

    const {method = 'GET', params = {}, headers = {}, body = null} = options;

    const url = new URL(apiUrl);

    // Voor GET en DELETE requests, voeg parameters toe aan URL
    if ((method === 'GET' || method === 'DELETE') && Object.keys(params).length > 0) {
        Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
    }

    const fetchOptions = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
    };

    // Voor POST en PUT requests, voeg body toe
    if ((method === 'POST' || method === 'PUT') && body) {
        fetchOptions.body = typeof body === 'string' ? body : JSON.stringify(body);
    } else if ((method === 'POST' || method === 'PUT') && Object.keys(params).length > 0) {
        // Als er geen body is maar wel params, gebruik params als body
        fetchOptions.body = JSON.stringify(params);
    }

    try {
        const response = await fetch(url, fetchOptions);

        if (!response.ok) {
            const error = new Error(`HTTP error! status: ${response.status}`);

            error.status = response.status;
            // De foutbody (JSON-object/array, tekst of null) zodat aanroepers de reden kunnen tonen,
            // bijv. error.body.enrollValidationResult of error.body.planningValidationResult.
            error.body = await readErrorBody(response);

            throw error;
        }

        // Check of response content heeft voordat we proberen te parsen
        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
            return await response.json();
        } else {
            return await response.text();
        }
    } catch (error) {
        console.error('Fetching data failed', error);
        throw error;
    }
}

/**
 * Leest de body van een foutresponse: JSON als het kan, anders tekst, null als er niets is.
 * @param {Response} response
 * @returns {Promise<object|string|null>}
 */
async function readErrorBody(response) {
    try {
        const text = await response.text();

        if (!text) return null;

        try {
            return JSON.parse(text);
        } catch {
            return text;
        }
    } catch {
        return null;
    }
}
